(() => {
  const TRANSPARENT = ['transparent', 'rgba(0, 0, 0, 0)', 'rgba(0,0,0,0)']

  const isTransparent = (value) => !value || TRANSPARENT.includes(value.toLowerCase())

  const resolveBackgroundColor = (element) => {
    if (!element) return ''

    const style = window.getComputedStyle(element)
    if (!isTransparent(style.backgroundColor)) return style.backgroundColor

    for (const child of element.children) {
      const childStyle = window.getComputedStyle(child)
      if (!isTransparent(childStyle.backgroundColor)) return childStyle.backgroundColor
    }

    return ''
  }

  const applyDividerColors = (dividerRoot) => {
    const wrapper = dividerRoot.closest('.shopify-section')
    if (!wrapper) return

    const previousWrapper = wrapper.previousElementSibling
    const nextWrapper = wrapper.nextElementSibling

    const autoEnabled = dividerRoot.dataset.interlockAutoColor !== 'false'
    const topFallback = (dividerRoot.dataset.interlockTopFallback || '').trim()
    const bottomFallback = (dividerRoot.dataset.interlockBottomFallback || '').trim()

    let topColor = ''
    let bottomColor = ''

    if (autoEnabled) {
      if (previousWrapper && previousWrapper.classList.contains('shopify-section')) {
        topColor = resolveBackgroundColor(previousWrapper)
      }
      if (nextWrapper && nextWrapper.classList.contains('shopify-section')) {
        bottomColor = resolveBackgroundColor(nextWrapper)
      }
    }

    if (!topColor && topFallback) topColor = topFallback
    if (!bottomColor && bottomFallback) bottomColor = bottomFallback

    if (topColor) {
      dividerRoot.style.setProperty('--interlock-divider-top', topColor)
    }
    if (bottomColor) {
      dividerRoot.style.setProperty('--interlock-divider-bottom', bottomColor)
    }
  }

  const initDividers = () => {
    const dividerRoots = document.querySelectorAll('[data-interlock-divider="true"]')
    if (!dividerRoots.length) return

    dividerRoots.forEach((dividerRoot) => applyDividerColors(dividerRoot))
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDividers)
  } else {
    initDividers()
  }

  document.addEventListener('shopify:section:load', initDividers)
  document.addEventListener('shopify:section:reorder', initDividers)
})()
